import React from 'react';
import Payments from '../footerpayments/Payments';



const Footer = () => {
    return (
        <Payments />
    )
}

export default Footer